<template>
  <div class="cmp-distribution-orders-order_supplier_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddOrderClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          style="margin: 0px 20px"
          :value="basicFilter.supplier_order_id"
          :placeholder="$t('supplier_order_id')"
          :config="{
            borderStyle: 'bottom',
            width: '150px',
            noicon: true,
          }"
          @keyup="(e) => onInputKeyup(e, 'supplier_order_id')"
        ></InputField>

        <InputField
          style="margin: 0px 20px"
          :value="basicFilter.supplier"
          :placeholder="$t('supplier')"
          :config="{
            borderStyle: 'bottom',
            width: '124px',
            noicon: true,
          }"
          @keyup="(e) => onInputKeyup(e, 'supplier')"
        ></InputField>

        <Dropdown
          :style="{
            maxWidth: '155px',
            width: '155px !important',
            marginRight: '20px',
          }"
          :options="supplyOrderTypeTV"
          :selected="
            supplyOrderTypeTV.find(
              (e) => e.value == basicFilter.supply_order_type
            )
          "
          :placeholder="$t('supply_order_type')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('supply_order_type', e)"
        >
        </Dropdown>

        <InputField
          :value="basicFilter.catalog_no"
          :placeholder="$t('catalog_no')"
          :config="{
            borderStyle: 'bottom',
            width: '124px',
            noicon: true,
          }"
          @keyup="(e) => onInputKeyup(e, 'catalog_no')"
        ></InputField>

        <Dropdown
          :style="{ maxWidth: '135px', width: '135px !important' }"
          :options="accountedTV"
          :selected="
            accountedTV.find((e) => e.value == basicFilter.accounted_flag)
          "
          :placeholder="'Accounted'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onDropdownChange('accounted_flag', e)"
        >
        </Dropdown>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        :id="'distribution-orders-order_list'"
        :headers="headers"
        :items="list"
        class="order_list h1"
        :config="orderTableConfig"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td
              @click="onRowClicked(item)"
              v-bind="tdcon('supplier_order_date')"
            >
              <span style="font-weight: bold">{{
                item["supplier_order_date"]
              }}</span>
            </td>
            <td v-bind="tdcon('order_ref')">
              <span> {{ item["supplier_order_id"] }} </span>
            </td>
            <td v-bind="tdcon('description')">
              <TextField2
                style=""
                box
                id="description"
                :placeholder="$t('description')"
                :label="$t('description')"
                :value="item['description']"
                :disabled="false"
                :showLabel="false"
                :bb="'none'"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
              <!-- <span>{{ item["description"] }}</span> -->
            </td>
            <td v-bind="tdcon('supplier')">
              <span>{{ item["supplier_name"] }}</span>
            </td>
            <td v-bind="tdcon('order_type')">
              <span>{{ item["supply_order_type_name"] }}</span>
            </td>
            <td v-bind="tdcon('reference')">
              <span class="txtov" :title="item['reference']">{{
                item["reference"]
              }}</span>
            </td>
            <td v-bind="tdcon('recoupable_accounted')">
              <div class="ut-flex">
                <div style="min-width: 20px">
                  <div class="dt-checkbox v2 s1 disabled2">
                    <input
                      type="checkbox"
                      :name="'paid_flag'"
                      :id="'paid_flag'"
                      :checked="item['accounted_date']"
                      :disabled="true"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div style="flex: 1; margin-left: 4px">
                  <span v-if="item['accounted_date']">{{
                    item["accounted_date"]
                  }}</span>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('qty')">
              <span>{{ item["initial_qty"] }}</span>
            </td>
            <td v-bind="tdcon('order_value')">
              <div class="ut-flex ut-jend">
                <div>
                  {{ item["order_value"] }}
                </div>
                <div style="width: 25px; max-width: 25px; margin-left: 5px">
                  {{ item["currency_iso"] }}
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <!-- <img
                v-if="!item['invoice_id']"
                @click.stop="e => deleteStatement(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s2 ut-center"
              /> -->
              <img
                v-if="!item['accounted_date']"
                src="static/icons/delete.svg"
                @click.stop="(e) => onDelete(item)"
                class="dt-icon v5 s2"
                alt="Delete order"
                title="Delete order"
              />
            </td>

            <!-- <td v-bind="tdcon('options')" >
           
                <div class="dt-icon-container">
                  <img src="static/icons/delete.svg" @click.stop="(e) => onDelete(item)" class="dt-icon v5 s2" alt="Delete order" title="Delete order" />
                </div>
             
            </td> -->
          </tr>
        </template>
      </NTable>

      <div style="float: right; margin-top: 20px" class="ut-flex"></div>
    </div>

    <ModalContainer
      :modalKey="'deleteWarningModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <DeleteWarningModal
        :productList="deleteWarningProduct"
        @onDelete="onDeleteOrder"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addSupplierOrder'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AddSupplierOrderModal
        :supplyOrderTypeTV="supplyOrderTypeTV"
        @onAdd="onAddSupplierOrder"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addOrderLineModal'"
      :width="'medium'"
      @cancelled="onCancel"
    >
      <AddOrderLineModal
        @cancelled="onCancel"
        @onAdd="onAddOrderLine"
        @change="onSOProductChange"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'addAccountModal'"
      :width="'medium'"
      @cancelled="onCancel"
    >
      <AddAccountModal
        @cancelled="onCancel"
        @onAdd="onAddOrderLine"
        @change="onSOProductChange"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'finishOrderModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <FinishOrderModal @cancelled="onCancel" @finishOrder="onFinishOrder" />
    </ModalContainer>
    <!-- <ModalContainer
      :modalKey="'documentModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <DocumentsModal @cancelled="onCancel" />
    </ModalContainer> -->
    <ModalContainer
      :modalKey="'shippingDateModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <ShippingDateModal @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'shippingDateModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <ShippingDateModal @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      :modalKey="'shippingOrderLinesModal'"
      :width="'big'"
      @cancelled="onCancel"
    >
      <ShippingOrderLinesModal
        @update="onShipOrderLineUpdate"
        @cancelled="onCancel"
      />
    </ModalContainer>
    <ModalContainer
      :modalKey="'exchangeRateModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <ExchangeRateModal @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'costAmountModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <CostAmountModal @onCostConfirm="onCostConfirm" @cancelled="onCancel" />
    </ModalContainer>

    <Sidewindow :value="orderDetailsFlag" @closed="onCloseOrderSidewindow">
      <SupplierOrderSideWindow
        v-if="orderDetailsFlag"
        :distributionSupplierOrderDetails="distributionSupplierOrderDetails"
        @delete="onDelete"
      />
    </Sidewindow>
    <ModalContainer
      :modalKey="'importExcel'"
      :width="'medium'"
      @cancelled="onCancel"
    >
      <ImportExcelModal @import_excel="onImportExcel" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'progressBarModal'"
      :width="'small'"
    >
      <ProgressBarModal 
        :fileUploadingFlag="fileUploadingFlag"
        :fileUploaderDuration="fileUploaderDuration"
        :fileUploaderProgress="fileUploaderProgress"
        @cancelled="onCancel" 
      />
    </ModalContainer>
  </div>
</template>

<script>
//plugins
import InputField from "@plugins/text-field/input-field";

import NTable from "@/plugins/datatable/datatable";
import ProgressBarModal from '@plugins/progress-bar/progress-bar-modal';
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

//dt-plugins
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import Sidewindow from "../../../../dt-plugins/sidewindow/sidewindow";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
//store
import { distributionSupplierOrderActions } from "../../store/supplier_orders/actions";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/supplier_orders/types";

import { Subject } from "rxjs";

import { childOfOrEqual } from "../../../../router/functions";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { distributionSupplierOrderGetters } from "../../store/supplier_orders/getters";

import { createTV } from "../../../../models/text-value.model";

//modal
import DeleteWarningModal from "./supplier-order-delete-warning-modal.vue";
import AddSupplierOrderModal from "./add-supplier-order-modal.vue";
import AddOrderLineModal from "./add-orderline-modal.vue";

import ChangeProductModal from "./change-product-modal.vue";

import AddAccountModal from "./add-account-modal.vue";
import FinishOrderModal from "./finish-order-modal.vue";

// import DocumentsModal from "./documents-modal.vue";

import ShippingDateModal from "./shipping-date-modal.vue";

import ShippingOrderLinesModal from "./shipping-orderlines-modal.vue";

import ExchangeRateModal from "./exchange-rate-modal.vue";

import CostAmountModal from "./cost-amount-modal.vue";

import ImportExcelModal from './import-excel-modal.vue'
//routes
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";

import {
  distributionSupplierOrderListLDTRoutes,
  getDistributionSupplierOrderDetailsSelectable,
} from "../../router/routes";

import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

//component
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { MHTTPCL } from "../../../../services/http/http-client";
import { SupplierOrdersService } from "../../services/supplier.order.service";

import SupplierOrderSideWindow from "./supplier-order-sidewindow.vue";
import { handleCloseTab } from "../../../../dt-plugins/sidewindow/nav-tab";
import { mounted } from "vue2-dropzone";
import { waitForAnimation, subscribeSubject } from "@/utility";
import { getNoteRow ,wait  } from '../../../../utility';
const LDTConfig = {
  entityName: "order",
  ldtRoutes: distributionSupplierOrderListLDTRoutes,
  detailsSelectableFunction: getDistributionSupplierOrderDetailsSelectable,
  primaryKey: "supplier_order_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.DistributionSupplierOrderDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.DistributionSupplierOrderDetails.FETCH.SINGLE,
};

export default {
  mounted: async function () {},

  components: {
    InputField,
    NTable,
    Sidewindow,
    ModalContainer,
    DeleteWarningModal,
    AddSupplierOrderModal,
    AddOrderLineModal,
    ChangeProductModal,
    AddAccountModal,
    FinishOrderModal,
    // DocumentsModal,
    ShippingDateModal,
    ShippingOrderLinesModal,
    ExchangeRateModal,
    CostAmountModal,
    ImportExcelModal,
    ProgressBarModal,
    SupplierOrderSideWindow,
  },
  data() {
    return {
      orderTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
        rowHeight: 40,
      }),
      searchString: "",
      searchSubject$: new Subject(),
      selectedClickedOrder: null,
      deleteWarningProduct: [],
      fileUploaderDuration: 2400,
      fileUploaderProgress: 0,
      fileUploadingFlag: false,
    };
  },
  mixins: [
    createModalMixin("deleteWarningModal"),
    createModalMixin("addSupplierOrder"),
    createModalMixin("addOrderLineModal"),
    createModalMixin("addAccountModal"),
    createModalMixin("finishOrderModal"),
    createModalMixin("documentModal"),
    createModalMixin("shippingDateModal"),
    createModalMixin("exchangeRateModal"),
    createModalMixin("costAmountModal"),
    createModalMixin("shippingOrderLinesModal"),
    createModalMixin("importExcel"),
    createModalMixin("progressBarModal"),
    createLDTHost(LDTConfig),
    createFetchListMixin(
      ActionTypes.DistributionSupplierOrderList.FETCH.ALL,
      50
    ),
  ],
  mounted() {
    subscribeSubject(this, this.searchSubject$, (searchString) => {
      this.fetchListReset();
    });
  },
  computed: {
    ...mapGetterObject(storeNS, distributionSupplierOrderGetters),

    list: function () {
      return this.distributionSupplierOrderList?.supplier_orders || [];
    },

    supplyOrderTypeTV: function () {
      return createTV(
        this.distributionSupplierOrderList?.supply_order_types,
        "label",
        "value"
      );
    },
    accountedTV: function () {
      return [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ];
    },

    orderDetailsFlag: function () {
      return childOfOrEqualDetails(
        distributionSupplierOrderListLDTRoutes,
        this.$route
      );
    },
    headers: function () {
      return [
        createTableHeader("supplier_order_date", {
          text: this.$t("order_date"),
          mw: 100,
        }),
        createTableHeader("order_ref", { ta: "center" }),
        createTableHeader("description", {}),
        createTableHeader("supplier"),
        createTableHeader("order_type", {}),
        createTableHeader("reference", {}),
        createTableHeader("recoupable_accounted", { mw: 110 }),
        createTableHeader("qty", { text: this.$t("quantity"), ta: "center" }),

        createTableHeader("order_value", {
          ta: "right",
          text: this.$t("value"),
        }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    advancedSearchData: function () {
      return {};
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
  },

  created() {},

  methods: {
    ...mapActionObject(storeNS, distributionSupplierOrderActions),
    fetchAdvancedSearchData: function () {},

    onCostConfirm: function (supplier_order_id) {
      const distributionSupplierOrderDetails =
        (this.distributionSupplierOrderDetails || {})[supplier_order_id] || {};
      const supplier_order =
        distributionSupplierOrderDetails.supplier_order || {};

      this[ActionTypes.DistributionSupplierOrderDetails.FETCH.SINGLE]({
        flag: true,
        order: supplier_order,
        reload: true,
      });
    },

    onCancel: function () {
      closeModalRoute(this);
    },
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,

        supplier_order_id: undefined,

        catalog_no: undefined,

        supplier: undefined,

        supply_order_type: undefined,

        accounted_flag: undefined,
      };
    },
    onListScroll: function (value) {
      console.log("OOO");
      this.scrollSubject.next(value);
    },
    onAddOrderClick: function () {
      console.log("onAddOrderClick");
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_supplier_order",
        },
      });
    },

    onInputKeyup(event, name) {
      const value = event.target.value;
      console.log(value, "name:", name);
      this.basicFilter[name] = value;

      console.log("Basic Filter", this.basicFilter);
      this.searchSubject.next(value);
    },

    selectedRow: function (order) {
      return (
        this.selectedClickedOrder &&
        this.selectedClickedOrder["supplier_order_id"] ===
          order["supplier_order_id"]
      );
    },
    onRowClicked: function (order) {
      this.selectedClickedOrder = order;
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: order.supplier_order_id,
          tab: "overview",
        },
      });
    },
    onCloseOrderSidewindow: function () {
      this.selectedClickedOrder = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionSupplierOrderListLDTRoutes.names.list,
        });
      });
    },

    onDropdownChange(action, data) {
      console.log(action, data, this.supplyOrderTypeTV);
      this.basicFilter[action] = data.value;
      this.fetchListReset();
    },

    onDelete: async function (item) {
      const res =
        await SupplierOrdersService.supplierOrderDeleteConfirmationModalData(
          item.supplier_order_id
        );

      console.log("RES", res);

      const productLength = res.data.result.products.length;

      this.deleteWarningProduct = res.data.result.products;

      if (productLength > 0) {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "delete_warning_modal",
            supplier_order_id: item.supplier_order_id,
          },
        });
      } else {
        const confirmationResult = await confirmDelete(
          "Supplier Order",
          item.supplier_name
        );
        if (confirmationResult === "OK") {
          this.onDeleteOrder(item.supplier_order_id);
        }
        // const confirmationResult =await ConfirmationService.createP({
        //   body:this.$t('delete_supplier_order_no_relation_msg'),
        //   results: [
        //       createConfirmResult({
        //         value: "no",
        //         text: "No",
        //       }),
        //       createConfirmResult({
        //         value: "yes",
        //         text: "Yes",
        //         classes: ["v1"],
        //       })

        //   ],
        // })

        // if(confirmationResult=="yes")
        //   this.onDeleteOrder(item.supplier_order_id);
      }
    },

    onDeleteOrder: function (supplier_order_id) {
      console.log("::::::::", supplier_order_id);
      this[ActionTypes.DistributionSupplierOrderList.DELETE.SINGLE]({
        supplier_order_id: supplier_order_id,
      });

      const module = this.$store.getters.appNavItems.find(
        (e) => e.title == "Distribution"
      );
      console.log(module);
      const submodule = module.children.find(
        (e) => e.route == "supplier_order"
      );
      console.log(
        ":::::::::::::::::::::",
        submodule,
        module,
        ":::::::::::::::::::::::"
      );
      const details = submodule.children.find(
        (e) => e.route == supplier_order_id
      );
      handleCloseTab(this.$store, module, submodule, details);
      this.onCancel();
    },

    onAddSupplierOrder: async function (payload) {
      const res = await SupplierOrdersService.addSupplierOrder({ ...payload });
      console.log("RES",res)
      this.onCancel();
      this.fetchListReset();
      this.onRowClicked({supplier_order_id:res.data.supplier_order_id});
    },

    onAddOrderLine: function (payload) {
      console.log(":::::::::::::::::",payload,":::::::::::::::");
      this[ActionTypes.DistributionSupplierOrderOrderLines.INSERT.MULTIPLE](
       { supplier_order_id:payload }
      );
      this.onCancel();
    },

    onSOProductChange: function (payload) {
      //const { catalog_no ,product_id } = payload;

      this[ActionTypes.DistributionSupplierOrderSOProduct.UPDATE.SINGLE](
        payload
      );

      this.onCancel();
    },

    onFinishOrder: async function (payload) {
      this.onCancel();
      const { supplier_order_id } = payload;

      await SupplierOrdersService.finishOrder({ ...payload });

      const distributionSupplierOrderDetails =
        (this.distributionSupplierOrderDetails || {})[supplier_order_id] || {};
      const supplier_order =
        distributionSupplierOrderDetails.supplier_order || {};

      this[ActionTypes.DistributionSupplierOrderDetails.FETCH.SINGLE]({
        flag: true,
        order: supplier_order,
        reload: true,
      });
    },

    onShipOrderLineUpdate: function (payload) {
      this[ActionTypes.DistributionSupplierOrderSOrderLines.UPDATE.MULTIPLE](
        payload
      );
      this.onCancel();
    },
    onTextFieldValueChange: function (e, item) {
      console.log(e, item);
      const { name, value } = e;
      this[ActionTypes.DistributionSupplierOrderList.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onImportExcel:async function({ file , supplier_order_id}){
        const formData = new FormData();
        formData.append("section", "supplier_orders");
        formData.append("action", "import_excel_so");
        formData.append(
          "supplier_order_id",
          supplier_order_id
        );
       // formData.append("file_name_str", this.file?.name);
        formData.append("file_name", file);

        // const file_types_pattern = /\.(xls|xlsx|csv|txt|tab|tsv)$/i; ///\.Add file extesion

        // const matches = String(this.file?.name||'').match(file_types_pattern);
        // if(!matches){
        //   const confirmation =await  ConfirmationService.createP({
        //         body: this.$t("Only xls ,xlsx ,csv ,txt ,tab ,tsv file is allowed"),
        //         results: [
        //           createConfirmResult({
        //             value: "ok",
        //             text: "OK",
        //             classes: ["v1 s7"],
        //           }),
        //         ],
        //       })
    
        //   return;
        // }

        this.$router.push({
            ...this.$route,
            query: {
              modal: 'progress_bar_modal',
            },
          });
      

       // formData.append("file_type", matches[1]);
        this.fileUploadingFlag = true;
      
        await wait(5);
        this.fileUploaderProgress = 10;

        await wait(5);

        this.fileUploaderProgress = 30;
        await wait(5);

        this.fileUploaderProgress = 80;
        
        const res = await SupplierOrdersService.importExcel(formData)
        
        this.fileUploaderDuration = 600;
        await wait(5);
        console.log(this.file,"::::::::::",res)
        this[ActionTypes.DistributionSupplierOrderOrderLines.INSERT.MULTIPLE](
       { supplier_order_id:supplier_order_id }
      );
      this.onCancel();

        this.fileUploaderProgress = 100;

        await wait(600);
    
        this.onCancel();
    }
  },
};
</script>

<style lang="scss">
.cmp-distribution-orders-order_supplier_list {
  .dt-ntable.order_list {
    input.fc-control {
      border: 1px solid var(--sprt-85);
    }
    --ntable-height: calc(100vh - 185px);
    @media (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4),
      th:nth-child(7),
      td:nth-child(7) {
        display: none;
      }
    }

    td.account_name {
      font-weight: 800 !important;
    }
    td.options {
      .option-buttons {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  // button {
  //   float: right;
  //   height: 2.5em;

  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   transition: all 0.3s ease;
  //   border-radius: 5px;
  // }
  .dt-page--top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    & > div {
      margin: 0px 10px;
    }

    // .add-button {
    //   flex: 0.4;
    //   padding: 5px;
    //   display: flex;
    //   justify-content: center;
    // }
    // .search {
    //   flex: 2;
    // }
    // .users-dropdown {
    //   flex: 2;
    // }
    .right-space {
      flex: 8;
    }

    .dropdown {
      //flex: 5;
      width: 180px;
      //min-width: 220px;
      margin-left: 10px;
    }
    .input-field-container {
      //flex: 5;
      width: 180px;
      max-width: 200px;
      margin-left: 10px;
      margin-right: 20px;
    }
  }
}
</style>